import { MutationTree } from 'vuex';
import { IState } from './types';

const mutations: MutationTree<IState> = {
  setUserInfo(state, info) {
    state.info = info;
  }
};

export default mutations;
